import {
  GET_INDUSTRY_CATEGORY_LIST_REQUEST,
  GET_INDUSTRY_CATEGORY_LIST_SUCCESS,
  GET_INDUSTRY_CATEGORY_LIST_FAILURE,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { transformToChildrenStructure } from '../../utils/treeUtils';

const initialState = {
  industryCategoryList: [],
  loading: false,
  errorMessage: '',
}

export default (state = initialState, action) => {
  state = {
    ...state,
    errorMessage: '',
  }

  switch (action.type) {
    case GET_INDUSTRY_CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case GET_INDUSTRY_CATEGORY_LIST_SUCCESS: {
      const transformedData = transformToChildrenStructure(
        action.payload.industryCategoryList,
        ['industry_middle_categories', 'industry_minor_categories']
      );
      return {
        ...state,
        industryCategoryList: transformedData,
        loading: false,
      }
    }
    case GET_INDUSTRY_CATEGORY_LIST_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error ? action.payload.error : errMessages.ERR_BAD_FORMAT,
        loading: false,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/industryCategory.js